import { computed } from 'vue';
import { usePhvInputStore } from '@/features/Sparten/phv/useInputStore';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';

export const isTarifgruppeBeamter = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.TARIFGRUPPE,
    SIMPLE_CHOICE_META.TARIFGRUPPE_BEAMTER,
  ).includes(usePhvInputStore().tarifgruppe);

export const isTarifgruppeBeamterReactive = computed(() =>
  isTarifgruppeBeamter(),
);

export const hasDiensthaftpflicht = computed(
  () =>
    isTarifgruppeBeamterReactive.value && usePhvInputStore().diensthaftpflicht,
);

export const hasTarifWithMinors = computed(() =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.TARIFART,
    SIMPLE_CHOICE_META.TARIFART_HAS_CHILDREN,
  ).includes(usePhvInputStore().tarifart),
);
